import React, { useState, useEffect } from "react";
import { TextField, Button, Select, MenuItem } from "@mui/material";
import { useMutation } from "react-query";
import axios from "axios";
import { useQuery } from "react-query";
const StudentAttendance = () => {
  // Function to get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0]; // YYYY-MM-DD format
  };

  const [attendance, setAttendance] = useState({
    date: getCurrentDate(),
    status: "Present",
    notes: "",
  });

  useEffect(() => {
    setAttendance((prevAttendance) => ({
      ...prevAttendance,
      date: getCurrentDate(),
    }));
  }, []);

  const handleChange = (e) => {
    setAttendance({ ...attendance, [e.target.name]: e.target.value });
  };

  // React Query Mutation for submitting attendance
  const { mutate, isLoading, isSuccess, isError,data } = useMutation(
    async (attendanceData) => {
      const token = sessionStorage.getItem("studentToken");
      const response = await axios.post(
        "http://localhost:8000/api/auth/studentAttendance",
        attendanceData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    },
    {
      onSuccess: (data) => {
      
        alert("Attendance submitted successfully!");
      },
      onError: (error) => {
      
        alert("Attendance already submitted for today..");
      },
    }
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Prepare the payload
    const attendancePayload = {
      records: {
        status: attendance.status,
        notes:attendance.notes
      },
    };

    mutate(attendancePayload);
  };

  return (
    <form onSubmit={handleSubmit} style={{ maxWidth: "400px", margin: "auto" }}>
      <TextField
        label="Date"
        name="date"
        value={attendance.date}
        InputProps={{ readOnly: true }}
        fullWidth
        required
      />
      <Select
        name="status"
        value={attendance.status}
        onChange={handleChange}
        fullWidth
        style={{ margin: "20px 0" }}
      >
        <MenuItem value="Present">Present</MenuItem>
        <MenuItem value="Absent">Absent</MenuItem>
      </Select>
      <TextField
        label="Notes (Optional)"
        name="notes"
        value={attendance.notes}
        onChange={handleChange}
        fullWidth
        multiline
        rows={2}
      />
      <Button
        type="submit"
        variant="contained"
        color="primary"
        style={{ marginTop: "20px" }}
        disabled={isLoading}
      >
        {isLoading ? "Submitting..." : "Submit Attendance"}
      </Button>
      {isSuccess && <p>Attendance submitted successfully!</p>}
      {isError && <p style={{color:"red"}}>Attendance already submitted for today..</p>}
    </form>
  );
};

export default StudentAttendance;
